import { Box, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { FaqType } from "../../Models/Auth";
import { fetchFaqs, getRemoteValue } from "../../Utils/firebase";
import CAccordion from "../CAccordion/CAccordion";
import { useMediaQuery } from "../CustomHook/useMediaQuery";
import Spinner from "../Spinners/Spinner";

const Faq = () => {
  const [faqs, setFaqs] = useState<FaqType[]>([]);
  const [loading, setLoading] = useState(true); // Yüklenme durumu

  const isDesktop = useMediaQuery();

  useEffect(() => {
    fetchFaqs()
      .then((faqData: FaqType[]) => {
        setFaqs(faqData);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="md:mt-1">
      <Box
        component="img"
        sx={{
          width: "100%",
        }}
        alt="colendi"
        src={isDesktop ? "/faq-banner.png" : "/faq-mobile-banner.png"}
      />
      <div className="md:p-[4%] lg:p-[8%] !py-8 !pb-8 px-4 ">
        <Stack justifyContent={"center"} alignItems={"center"}>
          <h1 className="text-[18px] ml:text-[36px] font-bold leading-none">
            {getRemoteValue("faq")}
          </h1>
          <h4 className="text-[14px] ml:text-[16px] font-normal leading-none mt-6">
            {getRemoteValue("faq_desc")}
          </h4>
        </Stack>
        {loading ? (
          <Spinner />
        ) : (
          <Stack className="mt-8 ml:mt-12">
            <CAccordion items={faqs} />
          </Stack>
        )}
      </div>
    </div>
  );
};

export default Faq;
